import React, { useState, useEffect, useRef } from 'react';
import { CCard, CCol, CRow, CBadge, CProgress, CProgressBar, CSpinner, CDropdownMenu, CDropdownToggle, CDropdownItem, CDropdown } from '@coreui/react';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './ProjectDetails.css';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import ThingsToConsider from '../aimhi-widgets/ThingToConsider';
import $axios from 'src/utils/axios';
import IP from '../../StoreGlobal/IP';
import Notifications from '../../websocket/notifications';
import { useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';
import Loading from '../aimhi-widgets/Loading';
import { requestSowNotifications } from 'src/redux/actions/notifications';
import useSubscriptionCheck from 'src/utils/useSubscriptionCheck';
import { useDialog } from 'src/utils/DialogContext';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DownloadReportWeekly, GetDependencyList, GetScopeOfWorkList, RecommenderDependencies } from 'src/request/Projects';
import { useParams, useLocation } from 'react-router-dom';
import { getReport } from 'src/request/Reports';
import { ceilToDecimalPlaces } from 'src/utils/ceilToDecimalPlaces';
import useCheckPermission from 'src/utils/useCheckPermission';
import { showError } from 'src/utils/swalError';
import ProjectTabs from '../projects/ProjectTabs';
import queryString from 'query-string';
import { triggerProjectRefetch } from 'src/store/feature/project/projectSlice';
import { useDispatch } from 'react-redux';
import { trackEvent } from 'src/utils/mixpanel';
import { mixPanelEvents } from 'src/utils/mixpanel';

const ProjectTask = (props) => {
  let accessToken = localStorage.getItem('token');
  const Swal = require('sweetalert2');
  const [loading, setLoading] = useState(true);
  const company_id = parseInt(localStorage.getItem('company_id'));
  const [taskItem, settaskItem] = useState([]);
  const [toggle, settoggle] = useState([]);
  const [depency, setdepency] = useState([]);
  const [sowOption, setSowOption] = useState([]);
  const [phasesOption, setphasesOption] = useState([]);
  const [recommenderDependency, setRecommenderDependency] = useState([]);
  const [showRecommenderDependency, setShowRecommenderDependency] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const redux_module = useSelector((state) => state.module.module);
  const { openDialog, closeDialog } = useDialog();
  const { refreshSubscription, handleSubscriptionRequest, NoCreditsLeft } = useSubscriptionCheck();
  const [date, setDate] = useState('');
  const { id: projectID } = useParams();
  const [searchParams, setSearchParams] = useState({});
  const { search } = useLocation();
  const checkPermission = useCheckPermission();
  const dispatch = useDispatch();


  useEffect(() => {
    const parsed = queryString.parse(search);
    setSearchParams(parsed);
  }, [search]);

  useEffect(() => {
    const getWeekly = (status) => {
      getReport(projectID, 'weekly', status).then((res) => {
        if (res.status == 200) {
          setDate(res.data.response.date);
        } else {
          console.log('error', res.data.response);
        }
      });
    };
    getWeekly(0);
    requestSowNotifications(company_id, projectID);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      await scopeofwork(projectID);
      await depencies(projectID);
      getRecommenderDependencies(projectID);
      if (searchParams?.phaseId && !loading) {
        setTimeout(() => {
          const el = document.getElementById(`task-${searchParams.phaseId}`);
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            });
          }
        }, 400);
      }
    };
    fetchData();
    getsowlist();
    getphases();
  }, [projectID, searchParams, loading]);

  useEffect(() => {
    const toggleData = async () => {
      await toggleShow(searchParams?.phaseId, true, taskItem);
    };
    if (searchParams?.phaseId) {
      toggleData();
    }
  }, [taskItem]);

  useEffect(() => {
    if (redux_module == 'project-scope-of-work') {
      const n = new Notifications();
      n.request_sow_notifications(company_id, projectID);
    }
  }, [redux_module]);

  const allPhases = taskItem.map((item) => item.Phase);
  const uniquePhases = [...new Set(allPhases)];

  const toggleShow = (value, isId = false, baseData) => {
    if (isId) {
      baseData.forEach((e) => {
        const data = e.Task.find((x) => x.sow_id === parseInt(value));
        if (data) {
          value = e.Phase;
        }
      });
    }
    const shownState = toggle.slice();
    const index = shownState.indexOf(value);

    if (index >= 0) {
      shownState.splice(index, 1);
      settoggle(shownState);
    } else if (value === 'all') {
      settoggle(uniquePhases);
      setRecommenderDependencies();
    } else {
      shownState.push(value);
      settoggle(shownState);
    }
  };

  const changeprio = (e, Index, scopeIndex) => {
    const newArr = [...taskItem];
    newArr[scopeIndex].Task[Index].Priority = e.target.value;
    settaskItem(newArr);
  };

  const changestatus = (e, Index, scopeIndex) => {
    const newArr = [...taskItem];
    newArr[scopeIndex].Task[Index].Status = e.target.value;
    settaskItem(newArr);
  };

  const showRecommenderDependencies = (isSet) => {
    setShowRecommenderDependency(isSet);
  };

  const scopeofwork = async (project_id) => {
    const sowUrl = `${company_id}/${project_id}`;
    const descUrl = `2?project_id=${project_id}`;
    let endpointUrl = searchParams?.order_by === 'Description' ? descUrl : sowUrl;
    await $axios
      .get(IP + `sow/details/${endpointUrl}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        settaskItem(res?.data.response);
        setLoading(false);
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.log('projectdetails/ProjectOverview.js', ' ', 'line 264', error);
      });
  };

  const getRecommenderDependencies = (project_id) => {
    RecommenderDependencies(project_id)
      .then((res) => {
        if (res.data.data.length > 0) {
          const updatedData = res.data.data.map((item) => ({
            ...item,
            dependencies: item.dependencies.map((dep) => ({
              label: dep.value === 0 ? 'None' : dep.label,
              value: dep.value === 0 ? '0' : dep.value,
            })),
          }));
          setRecommenderDependency(updatedData);
          setShowRecommenderDependency(true);
        } else {
          setShowRecommenderDependency(true);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setShowRecommenderDependency(false);
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
      });
  };

  const setRecommenderDependencies = () => {
    const newTaskItem = [...taskItem];
    const updatedTaskItem = newTaskItem.map((phase) => {
      phase.Task.forEach((task) => {
        const matchingDependency = recommenderDependency.find((dep) => dep.sow_id === task.sow_id);
        if (matchingDependency) {
          task.Dependencies = matchingDependency.dependencies;
          task.recommender = 1;
        }
      });
      return phase;
    });
    settaskItem(updatedTaskItem);
  };

  const depencies = (project_id) => {
    const payload = {
      project_id,
      company_id,
    }
    GetDependencyList(payload)
      .then((res) => {
        const uniqueDependencies = Array.from(new Set(res.data.response.map((dep) => dep.value)));
        const uniqueDependencyObjects = uniqueDependencies.map((value) => {
          return res.data.response.find((dep) => dep.value === value);
        });
        setdepency(uniqueDependencyObjects);
      })
      .catch((error) => {
        console.log('projectdetails/ProjectOverview.js', ' ', 'line 281', error);
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
      });
  };

  const handleDeselectAll = () => {
    scopeofwork(projectID);
  };

  const handleAccept = () => {
    const newTaskItem = [...taskItem];

    newTaskItem.forEach((item, scopeIndex) => {
      item.Task.forEach((itemtask, innerIndex) => {
        autosave(
          {
            id: itemtask.id,
            dependencies: itemtask.Dependencies,
          },
          innerIndex,
          scopeIndex,
        );
      });
    });
    settaskItem(newTaskItem);
  };

  const autosave = (data, Index, scopeIndex) => {
    if (data.dependencies) {
      let minusLength = data.dependencies.length - 1;
      const includeNone = data.dependencies.filter((dependency) => dependency.value == 0);
      const excludeNone = data.dependencies.filter((dependency) => dependency.value != 0);

      if (excludeNone.length >= 1 && includeNone.length == 1) {
        if (data.dependencies[minusLength].value == 0) {
          data.dependencies = includeNone;

          Swal.fire({
            title: '<div class="swaltitle">WARNING</div>',
            text: 'By selecting none option, your current selected dependencies will be removed.',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
              icon: 'swal-icon-size',
              confirmButton: 'btn confirm',
              cancelButton: 'btn cancel',
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.isConfirmed) {
              $axios
                .post(IP + 'sow/save', {
                  data,
                  headers: {
                    'Content-Type': 'appliation/json',
                    Authorization: `Bearer ${accessToken}`,
                  },
                })
                .then((res) => {
                  if (res?.data?.status === 1 && res?.data?.response === 2) {
                    Swal.fire({
                      title: 'Changes Submitted',
                      icon: 'success',
                      text: 'The changes were submitted successfully and are now pending approval.',
                    })
                  }
                  trackEvent(mixPanelEvents.SAVE_SOW, {
                    'Project ID': projectID,
                    'Source': 'SOW - Dependency',
                  });

                  if (typeof data.dependencies != 'undefined') {
                    let arr = [...taskItem];
                    arr[scopeIndex].Task[Index].Dependencies.push(...data.dependencies);

                    settaskItem(arr);
                  }

                  if (res.data.status == 1) {
                    if (res.data.response == 1) {
                      requestSowNotifications(company_id, projectID);
                      scopeofwork(projectID);
                      dispatch(triggerProjectRefetch(projectID));
                    }
                  } else {
                    Swal.fire({
                      icon: 'error',
                      title: res.data.response,
                      text: res.data.description,
                      confirmButtonColor: '#23303D',
                    });

                    scopeofwork(projectID);
                  }
                })
                .catch((error) => {
                  console.log(error);
                  if (error?.response?.status === 403) {
                    showError(error?.response?.data?.response, "Permission Denied");
                    return;
                  }
                });
            } else if (result.isDenied) {
              Swal.fire('Changes saved', '', 'info');
            }
          });
        } else if (data.dependencies[minusLength].value != 0) {
          data.dependencies = excludeNone;
          $axios
            .post(IP + 'sow/save', {
              data,
              headers: {
                'Content-Type': 'appliation/json',
                Authorization: `Bearer ${accessToken}`,
              },
            })
            .then((res) => {
              if (res?.data?.status === 1 && res?.data?.response === 2) {
                Swal.fire({
                  title: 'Changes Submitted',
                  icon: 'success',
                  text: 'The changes were submitted successfully and are now pending approval.',
                })
              }
              if (res?.data?.status === 1 && res?.data?.response === 2) {
                Swal.fire({
                  title: 'Changes Submitted',
                  icon: 'success',
                  text: 'The changes were submitted successfully and are now pending approval.',
                })
              }

              trackEvent(mixPanelEvents.SAVE_SOW, {
                'Project ID': projectID,
                'Source': 'SOW - Dependency',
              });

              if (typeof data.dependencies != 'undefined') {
                let arr = [...taskItem];
                arr[scopeIndex].Task[Index].Dependencies.push(...data.dependencies);

                settaskItem(arr);
              }

              if (res.data.status == 1) {
                if (res.data.response == 1) {
                  requestSowNotifications(company_id, projectID);
                  scopeofwork(projectID);
                  dispatch(triggerProjectRefetch(projectID));
                }
              } else {
                Swal.fire({
                  icon: 'error',
                  title: res.data.response,
                  text: res.data.description,
                  confirmButtonColor: '#23303D',
                });

                scopeofwork(projectID);
              }
            })
            .catch((error) => {
              console.log(error);
              if (error?.response?.status === 403) {
                showError(error?.response?.data?.response, "Permission Denied");
                return;
              }
            });
        }
      }

      if (excludeNone.length <= 0 && includeNone.length >= 1) {
        data.dependencies = includeNone;
        $axios
          .post(IP + 'sow/save', {
            data,
            headers: {
              'Content-Type': 'appliation/json',
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((res) => {
            if (res?.data?.status === 1 && res?.data?.response === 2) {
              Swal.fire({
                title: 'Changes Submitted',
                icon: 'success',
                text: 'The changes were submitted successfully and are now pending approval.',
              })
            }
            trackEvent(mixPanelEvents.SAVE_SOW, {
              'Project ID': projectID,
              'Source': 'SOW - Dependency',
            });

            if (typeof data.dependencies != 'undefined') {
              let arr = [...taskItem];
              arr[scopeIndex].Task[Index].Dependencies.push(...data.dependencies);
              settaskItem(arr);
            }

            if (res.data.status == 1) {
              if (res.data.response == 1) {
                requestSowNotifications(company_id, projectID);
                scopeofwork(projectID);
                dispatch(triggerProjectRefetch(projectID));
              }
            } else {
              Swal.fire({
                icon: 'error',
                title: res.data.response,
                text: res.data.description,
                confirmButtonColor: '#23303D',
              });

              scopeofwork(projectID);
            }
          })
          .catch((error) => {
            console.log(error);
            if (error?.response?.status === 403) {
              showError(error?.response?.data?.response, "Permission Denied");
              return;
            }
          });
      }

      if (excludeNone.length >= 1 && includeNone.length <= 0) {
        data.dependencies = excludeNone;
        $axios
          .post(IP + 'sow/save', {
            data,
            headers: {
              'Content-Type': 'appliation/json',
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((res) => {
            if (res?.data?.status === 1 && res?.data?.response === 2) {
              Swal.fire({
                title: 'Changes Submitted',
                icon: 'success',
                text: 'The changes were submitted successfully and are now pending approval.',
              })
            }
            trackEvent(mixPanelEvents.SAVE_SOW, {
              'Project ID': projectID,
              'Source': 'SOW - Dependency',
            });

            if (typeof data.dependencies != 'undefined') {
              let arr = [...taskItem];
              arr[scopeIndex].Task[Index].Dependencies.push(...data.dependencies);
              settaskItem(arr);
            }

            if (res.data.status == 1) {
              if (res.data.response == 1) {
                requestSowNotifications(company_id, projectID);
                scopeofwork(projectID);
                dispatch(triggerProjectRefetch(projectID));
              }
            } else {
              Swal.fire({
                icon: 'error',
                title: res.data.response,
                text: res.data.description,
                confirmButtonColor: '#23303D',
              });
              scopeofwork(projectID);
            }
          })
          .catch((error) => {
            console.log(error);
            if (error?.response?.status === 403) {
              showError(error?.response?.data?.response, "Permission Denied");
              return;
            }
          });
      }

      if (excludeNone.length === 0 && includeNone.length === 0) {
        $axios
          .post(IP + 'sow/save', {
            data,
            headers: {
              'Content-Type': 'appliation/json',
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((res) => {
            if (res?.data?.status === 1 && res?.data?.response === 2) {
              Swal.fire({
                title: 'Changes Submitted',
                icon: 'success',
                text: 'The changes were submitted successfully and are now pending approval.',
              })
            }
            trackEvent(mixPanelEvents.SAVE_SOW, {
              'Project ID': projectID,
              'Source': 'SOW - Dependency',
            });

            if (typeof data.dependencies != 'undefined') {
              let arr = [...taskItem];
              arr[scopeIndex].Task[Index].Dependencies.push(...data.dependencies);
              settaskItem(arr);
            }
            if (res.data.status == 1) {
              if (res.data.response == 1) {
                requestSowNotifications(company_id, projectID);
                scopeofwork(projectID);
                dispatch(triggerProjectRefetch(projectID));
              }
            } else {
              Swal.fire({
                icon: 'error',
                title: res.data.response,
                text: res.data.description,
                confirmButtonColor: '#23303D',
              });
              scopeofwork(projectID);
            }
          })
          .catch((error) => {
            console.log(error);
            if (error?.response?.status === 403) {
              showError(error?.response?.data?.response, "Permission Denied");
              return;
            }
          });
      }
    } else if (data.status) {
      $axios
        .post(IP + 'sow/save', {
          data,
          headers: {
            'Content-Type': 'appliation/json',
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          if (res?.data?.status === 1 && res?.data?.response === 2) {
            Swal.fire({
              title: 'Changes Submitted',
              icon: 'success',
              text: 'The changes were submitted successfully and are now pending approval.',
            })
          }
          trackEvent(mixPanelEvents.SAVE_SOW, {
            'Project ID': projectID,
            'Source': 'SOW - Dependency',
          });

          if (typeof data.dependencies != 'undefined') {
            let arr = [...taskItem];
            arr[scopeIndex].Task[Index].Dependencies.push(...data.dependencies);
            settaskItem(arr);
          }

          if (res.data.status == 1) {
            if (res.data.response == 1) {
              requestSowNotifications(company_id, projectID);
              scopeofwork(projectID);
              dispatch(triggerProjectRefetch(projectID));
            }
          } else {
            Swal.fire({
              icon: 'error',
              title: res.data.response,
              text: res.data.description,
              confirmButtonColor: '#23303D',
            });
            scopeofwork(projectID);
          }
        })
        .catch((error) => {
          console.log(error);
          if (error?.response?.status === 403) {
            showError(error?.response?.data?.response, "Permission Denied");
            return;
          }
        });
    } else if (data.priority) {
      $axios
        .post(IP + 'sow/save', {
          data,
          headers: {
            'Content-Type': 'appliation/json',
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          if (res?.data?.status === 1 && res?.data?.response === 2) {
            Swal.fire({
              title: 'Changes Submitted',
              icon: 'success',
              text: 'The changes were submitted successfully and are now pending approval.',
            })
          }
          trackEvent(mixPanelEvents.SAVE_SOW, {
            'Project ID': projectID,
            'Source': 'SOW - Priority',
          });

          if (typeof data.dependencies != 'undefined') {
            let arr = [...taskItem];
            arr[scopeIndex].Task[Index].Dependencies.push(...data.dependencies);
            settaskItem(arr);
          }

          if (res.data.status == 1) {
            if (res.data.response == 1) {
              requestSowNotifications(company_id, projectID);
              scopeofwork(projectID);
              dispatch(triggerProjectRefetch(projectID));
            }
          } else {
            Swal.fire({
              icon: 'error',
              title: res.data.response,
              text: res.data.description,
              confirmButtonColor: '#23303D',
            });
            scopeofwork(projectID);
          }
        })
        .catch((error) => {
          console.log(error);
          if (error?.response?.status === 403) {
            showError(error?.response?.data?.response, "Permission Denied");
            return;
          }
        });
    }
  };

  const changedates = (value, Index, scopeIndex, category) => {
    const newArr = [...taskItem];

    if (category === 'itemtask.StartDate') {
      newArr[scopeIndex].Task[Index].StartDate = value;
    } else if (category === 'itemtask.EndDate') {
      newArr[scopeIndex].Task[Index].EndDate = value;
    }
    settaskItem(newArr);
  };

  const date_autosave = (data, Index, scopeIndex) => {
    let formattedData = { ...data };

    if (data.start_date) {
      const startDate = new Date(data.start_date);
      const timezoneOffset = startDate.getTimezoneOffset() * 60000;
      const adjustedDate = new Date(startDate - timezoneOffset);
      formattedData.start_date = adjustedDate.toISOString().split('T')[0];
    }
    if (data.end_date) {
      const endDate = new Date(data.end_date);
      const timezoneOffset = endDate.getTimezoneOffset() * 60000;
      const adjustedDate = new Date(endDate - timezoneOffset);
      formattedData.end_date = adjustedDate.toISOString().split('T')[0];
    }

    $axios
      .post(IP + 'sow/save', {
        data: formattedData,
        headers: {
          'Content-Type': 'appliation/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        if (res?.data?.status === 1 && res?.data?.response === 2) {
          Swal.fire({
            title: 'Changes Submitted',
            icon: 'success',
            text: 'The changes were submitted successfully and are now pending approval.',
          })
        }
        trackEvent(mixPanelEvents.SAVE_SOW, {
          'Project ID': projectID,
          'Source': 'SOW - Target Date/ Target Start',
        });

        if (typeof data.dependencies != 'undefined') {
          let arr = [...taskItem];
          arr[scopeIndex].Task[Index].Dependencies.push(...data.dependencies);

          settaskItem(arr);
        }

        if (res.data.status == 1) {
          if (res.data.response == 1) {
            requestSowNotifications(company_id, projectID);
            scopeofwork(projectID);
            dispatch(triggerProjectRefetch(projectID));
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: res.data.response,
            text: res.data.description,
            confirmButtonColor: '#23303D',
          });
          scopeofwork(projectID);
        }
      })
      .catch((error) => {
        console.log('projectdetails/ProjectOverview.js', ' ', 'line 318', error);
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
      });
  };

  const getsowlist = () => {
    $axios
      .get(IP + 'sow/list', {
        headers: {
          'Content-Type': 'appliation/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setSowOption(res.data.response);
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
      });
  };

  const getphases = () => {
    GetScopeOfWorkList(company_id)
      .then((res) => {
        setphasesOption(res.data.response);
      })
      .catch((error) => {
        console.log('projectdetails/ProjectTask.js', ' ', 'line 363', error);
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
      });
  };

  const dragItem = useRef();
  const dragOverItem = useRef();

  const dragStart = (e, position) => {
    dragItem.current = position;
  };

  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };

  const drop = (e) => {
    const copyListItems = [...taskItem];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    settaskItem(copyListItems);
  };
  const ItemBadge = ({ underBudget, delayed, incomplete }) => {
    let badge = [];

    if (underBudget == 1) {
      badge.push(
        <CBadge color="aimhi-success" className="badge-stats">
          WITHIN BUDGET
        </CBadge>,
      );
    } else {
      badge.push(
        <CBadge color="aimhi-danger" className="badge-stats">
          OVER BUDGET
        </CBadge>,
      );
    }

    if (incomplete == 1) {
      badge.push(
        <CBadge color="aimhi-success" className="badge-stats">
          INCOMPLETE
        </CBadge>,
      );
    } else {
      if (delayed == 0) {
        badge.push(
          <CBadge color="aimhi-success" className="badge-stats" style={{ marginTop: '3px' }}>
            ON-TIME
          </CBadge>,
        );
      } else {
        badge.push(
          <CBadge color="aimhi-danger" className="badge-stats" style={{ marginTop: '3px' }}>
            DELAYED
          </CBadge>,
        );
      }
    }

    return badge;
  };

  const taskCard = taskItem.map((item, index) => {
    let scopeIndex = index;
    const taskdetails = item.Task.map((itemtask, innerIndex) => {
      let classifier = <div className="float-left left-design"></div>;
      let color = '';
      let colorstatus = '';
      if (itemtask.Priority == 'high') {
        color = 'red';
      } else if (itemtask.Priority == 'moderate') {
        color = 'yellow';
      } else {
        color = 'green';
      }

      if (itemtask.Status >= '100') {
        colorstatus = 'green';
      } else if (itemtask.Status >= '1' && itemtask.Status <= '99') {
        colorstatus = 'blue';
      } else if (itemtask.Status <= '0') {
        colorstatus = 'gray';
      }

      if (itemtask.risk_score <= 0.2) {
        classifier = <div className="float-left left-design-success"></div>;
      }
      if (itemtask.risk_score > 0.2 && itemtask.risk_score <= 0.4) {
        classifier = <div className="float-left left-design-semiwarning"></div>;
      }
      if (itemtask.risk_score > 0.4 && itemtask.risk_score <= 0.6) {
        classifier = <div className="float-left left-design-warning"></div>;
      }
      if (itemtask.risk_score > 0.6) {
        classifier = <div className="float-left left-design-danger"></div>;
      }
      return (
        <CCol xs="12" sm="12" md="12" lg="12" xl="12" key={`${itemtask.sow_id}-${innerIndex}`} style={{ padding: '0px' }}>
          {classifier}
          <CCard id={`task-${itemtask.sow_id}`} className="task-card" style={{ marginLeft: '30px' }}>
            <CRow>
              <CCol xs="12" sm="12" md="12" lg="3" id="Task">
                {itemtask.new == true ? <Select className="basic-single" classNamePrefix="select" isClearable={true} isSearchable={true} options={sowOption} /> : <span className="task-label">{itemtask.SOW}</span>}
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="6" className="text-center" id="Priority, Status and dates">
                <CRow>
                  <CCol xs="12" sm="12" md="12" lg="3" id="Priority" style={{ padding: '0px' }}>
                    <span className="top-label">Priority</span>
                    <br />
                    <select
                      className={`${color} select-design ${color === 'yellow' ? 'text-dark' : ''}`}
                      onChange={(e) => changeprio(e, innerIndex, scopeIndex)}
                      onBlur={(e) =>
                        autosave(
                          {
                            id: itemtask.id,
                            priority: e.target.value,
                          },
                          innerIndex,
                          scopeIndex,
                        )
                      }
                      value={itemtask.Priority}
                      disabled={checkPermission('/sow/save')}
                    >
                      <option style={{ backgroundColor: 'white' }} value=""></option>
                      <option style={{ backgroundColor: '#B42A19', color: 'white' }} value="high">
                        High
                      </option>
                      <option style={{ backgroundColor: '#FDFE54', color: 'black' }} value="moderate">
                        Moderate
                      </option>
                      <option style={{ backgroundColor: '#3A7D21', color: 'white' }} value="low">
                        Low
                      </option>
                    </select>
                  </CCol>
                  <CCol xs="12" sm="12" md="12" lg="3" id="Status" style={{ padding: '0px' }}>
                    <span className="top-label">Status</span>
                    <br />
                    <div className="progress-dropdown" style={{ marginTop: '3px' }}>
                      <div style={{ position: 'relative' }}>
                        <CProgress style={{ height: '15px' }}>
                          <div
                            id="editable"
                            style={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              color: itemtask.Status < 60 ? 'black' : 'white',
                              fontWeight: 'bold',
                            }}
                          >
                            <span>{itemtask.Status}</span>%
                          </div>
                          <CProgressBar value={itemtask.Status} className={colorstatus + ' ' + 'select-design'} />
                        </CProgress>
                      </div>
                    </div>
                  </CCol>
                  <CCol xs="12" sm="12" md="12" lg="3" className="text-center" id="Target Start and Actual Start">
                    <CRow>
                      <CCol xs="12" sm="12" md="12" lg="12" id="Target Start">
                        <span className="top-label">Target Start</span>
                        <br />
                        <DatePicker
                          className="border-2 border-black sow"
                          placeholderText="mm/dd/yyyy"
                          format="MM/dd/yyyy"
                          selected={itemtask.StartDate ? new Date(itemtask.StartDate) : null}
                          value={itemtask.StartDate}
                          onChange={(value) => {
                            const date = new Date(value);
                            const month = String(date.getMonth() + 1).padStart(2, '0');
                            const day = String(date.getDate()).padStart(2, '0');
                            const year = date.getFullYear();
                            const formattedValue = `${month}/${day}/${year}`;
                            changedates(formattedValue, innerIndex, scopeIndex, 'itemtask.StartDate');
                            date_autosave(
                              {
                                id: itemtask.id,
                                start_date: itemtask.StartDate,
                              },
                              innerIndex,
                              scopeIndex,
                            );
                          }}
                        />
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12" id="Actual Start">
                        <span className="top-label">Actual Start</span>
                        <br />
                        <span style={{ fontSize: '0.765625rem' }}>{itemtask.actual_start ? itemtask.actual_start : 'mm/dd/yyyy'}</span>
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol xs="12" sm="12" md="12" lg="3" className="text-center" id="Target End and Actual End">
                    <CRow>
                      <CCol xs="12" sm="12" md="12" lg="12" id="Target End">
                        <span className="top-label">Target End</span>
                        <br />
                        <DatePicker
                          className="border-2 border-black sow"
                          placeholderText="mm/dd/yyyy"
                          selected={itemtask.EndDate ? new Date(itemtask.EndDate) : null}
                          value={new Date(itemtask.EndDate)}
                          onChange={(value) => {
                            const date = new Date(value);
                            const month = String(date.getMonth() + 1).padStart(2, '0');
                            const day = String(date.getDate()).padStart(2, '0');
                            const year = date.getFullYear();
                            const formattedValue = `${month}/${day}/${year}`;
                            changedates(formattedValue, innerIndex, scopeIndex, 'itemtask.EndDate');
                            date_autosave(
                              {
                                id: itemtask.id,
                                end_date: itemtask.EndDate,
                              },
                              innerIndex,
                              scopeIndex,
                            );
                          }}
                        />
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12" id="Actual End">
                        <span className="top-label">Actual End</span>
                        <br />
                        <span style={{ fontSize: '0.765625rem' }}>{itemtask.actual_end ? itemtask.actual_end : 'mm/dd/yyyy'}</span>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="3" className="text-center" id="Dependency and Dots">
                <CRow>
                  <CCol xs="12" sm="12" md="12" lg="10" className="text-center" id="Dependency" style={{ paddingRight: '0px' }}>
                    <CCol xs="12" sm="12" md="12" lg="12">
                      <span className="top-label">Dependency</span>
                      <br />
                      <MultiSelect
                        options={depency.filter((option) => option.value !== itemtask.id)}
                        value={itemtask.Dependencies}
                        onChange={(e) =>
                          autosave(
                            {
                              id: itemtask.id,
                              dependencies: e,
                            },
                            innerIndex,
                            scopeIndex,
                          )
                        }
                        labelledBy="Select"
                        className={itemtask.recommender !== 1 ? 'multi-select-design' : 'multi-select-design-recommender'}
                        disabled={checkPermission('/sow/save')}
                        style={{ textAlign: 'left', border: '1px solid #ff8b67' }}
                      >
                        <div className="panel-content"></div>
                      </MultiSelect>
                    </CCol>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCard>
        </CCol>
      );
    });
    const progressPercentage = ceilToDecimalPlaces(item.ProgressPercentage, 2);
    const totalBudget = ceilToDecimalPlaces(item.Total_Budget, 2);
    const totalCost = ceilToDecimalPlaces(item.Total_Cost, 2);
    const itemtask = item.Task[0];
    return (
      <CCol xs="12" sm="12" md="12" lg="12" style={{ padding: '1px', marginTop: '20px' }} onDragStart={(e) => dragStart(e, index)} onDragEnter={(e) => dragEnter(e, index)} onDragEnd={drop} draggable key={index}>
        <CCard style={{ padding: '20px', marginBottom: '0' }} className="shadow" onClick={() => toggleShow(item.Phase)}>
          <CRow>
            <CCol xs="12" sm="12" md="4" lg="3" xl="3" style={{ marginTop: '10px' }}>
              <span className="float-left circle-number">
                <span>{index + 1}</span>
              </span>
              {item.new == true ? (
                <div style={{ marginLeft: '10px' }}>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    options={phasesOption}
                  />
                </div>
              ) : (
                <div className="sow-label">{item.Phase.toUpperCase()}</div>
              )}
            </CCol>

            <CCol xs="12" sm="12" md="1" lg="1" className="float-left text-center" style={{ paddingTop: '10px' }}>
              <CCol xs="12" sm="12" md="12" lg="12">
                <ItemBadge underBudget={item.under_budget} delayed={item.delayed} incomplete={item.incomplete} />
              </CCol>
            </CCol>
            <CCol md="7" lg="6" style={{ paddingLeft: '40px' }}>
              <CCol md="12" lg="12" className="float-right">
                <CRow>
                  <CCol xs="6" sm="6" md="6" lg="6">
                    <span className="budget-label">Total Budget</span>
                    <div className="budget-value">
                      <div style={{ textAlign: 'left' }}>
                        ₱
                        <NumberFormat value={totalBudget} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                      </div>
                    </div>
                  </CCol>
                  <CCol xs="6" sm="6" md="6" lg="6">
                    <div className="float-right">
                      <div className="budget-label" style={{ textAlign: 'right' }}>
                        Total Cost
                      </div>
                      <div className="budget-value">
                        <div style={{ textAlign: 'right' }}>
                          ₱
                          <NumberFormat value={totalCost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
                <CProgress size="md">
                  <CProgressBar
                    color="aimhi-textlight-neutral"
                    value={totalBudget === 0 ? 0 : totalCost}
                    max={totalBudget === 0 ? 1 : totalBudget}
                    showPercentage
                    className="text-white"
                  />
                </CProgress>
              </CCol>
            </CCol>

            <CCol xs="12" sm="12" md="2" lg="2" className="align-center">
              <div className="circular-progress-size">
                <CircularProgressbarWithChildren
                  className="circular-progress-size"
                  value={progressPercentage}
                  text={`${progressPercentage}%`}
                  styles={{
                    path: {
                      stroke: '#351D75',
                      strokeLinecap: 'butt',
                      transition: 'stroke-dashoffset 0.5s ease 0s',
                      transformOrigin: 'center center',
                      circleRatio: '0',
                      strokeWidth: '-10',
                    },
                    trail: {
                      stroke: '#9c9c9c',
                      strokeLinecap: 'butt',
                      transform: 'rotate(0.25turn)',
                      transformOrigin: 'center center',
                      circleRatio: '0',
                      strokeWidth: '-10',
                    },
                    text: {
                      fill: '#23303D',
                      fontSize: '20px',
                      fontWeight: '700',
                    },
                    background: {
                      fill: '#54c2a2',
                    },
                  }}
                />
              </div>
              <span className="status-label align-text-mobile">Progress</span>
            </CCol>
          </CRow>
        </CCard>
        <CCol xs="12" sm="12" md="12" lg="12" style={{ padding: '0px' }}>
          <div className={`transition-all duration-300 ${toggle.includes(item.Phase) ? 'opacity-100' : 'max-h-0 overflow-hidden opacity-0'}`}>{taskdetails}</div>
        </CCol>
      </CCol>
    );
  });

  const handleDownload = async (project_id, type) => {
    setIsLoading(true);
    const { balance, status } = await refreshSubscription();
    const [start_date, end_date] = date.split(' - ').map((d) => d.trim());

    const proceedDownload = async () => {
      try {
        DownloadReportWeekly(project_id, start_date, end_date, type);
        closeDialog();
      } catch (error) {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        Swal.fire({
          title: 'Oopss',
          icon: 'error',
          text: 'Something went wrong. Please try again',
        });
      } finally {
        setIsLoading(false);
      }
    };
    if (status === 0) {
      if (balance != null && +balance < 15) return (setIsLoading(false), NoCreditsLeft());
      openDialog({
        title: 'Power Tool Feature',
        message: `You have ${balance} credits. Get unlimited Power Tools for P250/month or pay P15 per use. Once you use your credits, there’s no going back—no refunds or changes. Are you sure you want to continue? If so, how would you like to proceed?`,
        onPrimaryAction: () => proceedDownload(),
        primaryActionText: 'Pay P15',
        onSecondaryAction: () => handleSubscriptionRequest().then((res) => res === 1 && proceedDownload()).finally(() => setIsLoading(false)),
        secondaryActionText: 'Subscribe for P250',
        iconType: 'info',
        iconColor: '#3B74BE',
        onClose: () => setIsLoading(false),
      });
    } else {
      proceedDownload();
    }
  };

  return (
    <>
      {loading ? <Loading /> : ''}
      <ProjectTabs />
      <CRow>
        <CCol xs="12" sm="12" md="9" lg="12" xl="9">
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
            {checkPermission('/project/download/reports/weekly') && (
              <CDropdown className="d-inline">
                <CDropdownToggle color="aimhi-textlight-neutral" variant="outline" size="sm" style={{ width: '155px' }}>
                  {isLoading ? (
                    <>
                      <CSpinner color="#23303D" size="sm" />
                      <span style={{ marginLeft: '8px' }}>Download SWA</span>
                    </>
                  ) : (
                    'Download SWA'
                  )}
                </CDropdownToggle>

                <CDropdownMenu>
                  <CDropdownItem onClick={() => handleDownload(projectID, 4)}>Current Week</CDropdownItem>
                  <CDropdownItem onClick={() => handleDownload(projectID, 7)}>Previous Week</CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            )}
          </div>
          {taskCard}
        </CCol>
        <CCol xs="12" sm="12" md="3" lg="12" xl="3">
          <ThingsToConsider project_id={projectID} show_all={toggleShow} onDecline={handleDeselectAll} onAccept={handleAccept} showRecommenderDependency={showRecommenderDependency} taskItem={taskItem} sowOrderBy={searchParams?.order_by} />
        </CCol>
      </CRow>
    </>
  );
};

export default ProjectTask;
